export const SECOND = 1000;
export const MINUTE = 60 * SECOND;
export const HOUR = 60 * MINUTE;
export const DAY = 24 * HOUR;

export const getStartDate = (duration: number, remainingDays: number): string => {
	const date = Date.now();
	const startDays = duration - remainingDays;
	const startTimestamp = date - (startDays * DAY);
	const startDate = new Date(startTimestamp);
	const formatter = new Intl.DateTimeFormat("ru");
	const formattedStartDate = formatter.format(startDate);

	return formattedStartDate;
};

export const getExpireDate = (remainingDays: number): string => {
	const date = Date.now();
	const expireTimestamp = date + (remainingDays * DAY);
	const expireDate = new Date(expireTimestamp);
	const formatter = new Intl.DateTimeFormat("ru");
	const formattedExpireDate = formatter.format(expireDate);

	return formattedExpireDate;
};

export const getRemainingDays = (startDate: string, daysLimit: number): number => {
	const expireDate = new Date(startDate);
	expireDate.setDate(expireDate.getDate() + daysLimit);
	const currentDate = new Date();
	const remainingTimeStamp = expireDate.getTime() - currentDate.getTime();
	const remainingTimeDays = remainingTimeStamp / DAY;

	return Math.floor(remainingTimeDays);
};

export const getMonth = (date: Date): string => {
	const formatter = new Intl.DateTimeFormat("ru-RU", { month: 'long' });
	const formattedDate = formatter.format(date);
	const month = formattedDate[0].toUpperCase() + formattedDate.slice(1, formattedDate.length);

	return month;
};

export const getYear = (date: Date): string => {
	const formatter = new Intl.DateTimeFormat("ru-RU", { year: 'numeric' });
	const year = formatter.format(date);

	return year;
};

export const isDayPassed = (date: string): boolean => {
	const startDate = new Date(date);
	const currentDate = new Date();
	const isPassed = (currentDate.getTime() - startDate.getTime()) > DAY;

	return isPassed;
};
